const page1Queries = [
  // {
  //   metric: "User Metrics ",
  //   function: "Total Users ",
  //   description:
  //     "Total number of users who have logged in and interacted with the app within a given time period ",
  // },
  // {
  //   metric: "User Metrics ",
  //   function: "Active Users ",
  //   description:
  //     "Users who have interacted with the app within a given time frame (7 days).",
  // },
  //     {
  //       "metric": "User Metrics ",
  //       "function": "First-Time Users ",
  //       "description": "Users with only a single recorded response timestamp "
  //     },
  // {
  //   metric: "User Metrics ",
  //   function: "Recurring Users ",
  //   description: "Users who have interacted with the app multiple times ",
  // },
  //     {
  //       "metric": "User Metrics ",
  //       "function": "Highest/ Lowest No. of users (Daily, Weekly, Monthly) ",
  //       "description": "Days, weeks, months having highest or lowest user count "
  //     },
  //     {
  //       "metric": "User Metrics ",
  //       "function": "Peak User Times/ Question Count (Daily, Weekly, Monthly) ",
  //       "description": "Distribution of user question count over days, weeks, months"
  //     },
  //     {
  //        "metric": "User Metrics",
  //         "function": "User Engagement Score",
  //         "description": "A metric that quantifies user engagement based on session duration, session count, and question count (interaction depth), normalized on a scale of 0-10.."
  //     },

  //   {
  //      "metric": "User Metrics",
  //      "function": "User Session Count",
  //      "description": "The number of sessions a user has participated in (considering session timeout as 30 minutes)."

  //   },
  //   {     "metric": "User Metrics",
  //         "function": "User Session Duration",
  //         "description": "The total time a user spends in the app per session."

  //   },
  //   {
  //      "metric":"Users Metrics",
  //      "function":"Users today",
  //      "description":"Count of unique users who asked questions today"

  // },
  //   {  "metric":"Users Metrics",
  //      "function":"User Conversion Rate",
  //      "description":"Ratio of returning users to first-time users"

  // },
  // { "metric":"Users Metrics",
  //      "function":"Power Users",
  //      "description":"Users contributing more than 35% of total questions"

  // },
  // {
  //   "metric":"Users Metrics",
  //      "function":"Inactive Users",
  //      "description":"Users with no query in past 7 days"

  // },
  // { "metric":"Users Metrics",
  //      "function":"Avg. Inactivity Period",
  //      "description":"Average duration of inactivity across all users"

  // },
  // {
  //   metric: "Users Metrics",
  //   function: "Top Feedback Givers",
  //   description: "Users who provided the most feedback comments",
  // },
  // {"metric":"Users Metrics",
  //      "function":"Top users by cache hit rate",
  //      "description":"Users whose queries were most frequently served from cache"

  // },
  // {"metric":"Users Metrics",
  //      "function":"Top users by SQL validity rate",
  //      "description":"Users whose generated SQL queries are valid most frequently (based on validation logic)"

  // },
  // {"metric":"Session Metrics",
  //      "function":"Avg. Session Duration",
  //      "description":"Average duration of all sessions over time"

  // },
  // {
  //  "metric":"Session Metrics",
  //      "function":"Avg. Sessions per user",
  //      "description":"Average number of sessions per user"
  // },
  // {
  //   "metric":"Session Metrics",
  //      "function":"Bounce Sessions",
  //      "description":"Sessions with only 1 question and no follow-up"
  // },
  // { "metric":"Session Metrics",
  //      "function":"Long Session Ratio",
  //      "description":"Percentage of sessions longer than 10 minutes or containing more than 5 questions"

  // },
  // {"metric":"Session Metrics",
  //      "function":"Total Session Count",
  //      "description":"Total number of sessions across all users"

  // },
  // {"metric":"Session Metrics",
  //      "function":"Avg. time to follow-up",
  //      "description":"Average time from first question to first follow-up in a session"

  // },
  // {"metric":"Session Metrics",
  //      "function":"Avg. questions per session",
  //      "description":"Average number of questions asked per session"

  // },
  // {"metric":"Session Metrics",
  //      "function":" Questions per session",
  //      "description":"Distribution of question count per session "

  // },
  // {
  //   "metric":"Session Metrics",
  //      "function":"Highest and Lowest Session Lengths",
  //      "description":"Sessions with maximum and minimum durations "

  // },
  // {
  //    "metric":"Session Metrics",
  //      "function":"Session Duration",
  //      "description":" Duration of each session individually"

  // },
  // {
  //    "metric":"Session Metrics",
  //      "function":"Highest Questions per session",
  //      "description":"Maximum number of questions asked in a single session"

  // }
  // {
  //   metric: "Question Metrics",
  //   function: "Feedback Sentiment Heatmap",
  //   description:
  //     "Heatmap showing the positive, negative and neutral sentiments of users from their feedback, classified into themes like UI-UX related, Sql related etc",
  // },

  {
    metric: "User Metrics",
    function: "Total Users",
    description:
      "Total number of users who have access to a specific indication.",
  },
  {
    metric: "User Metrics",
    function: "Active Users",
    description: "Users who have interacted with the agent within 7 days.",
  },
  {
    metric: "User Metrics",
    function: "Engaged Users",
    description: "Users who have asked more than one question.",
  },
  {
    metric: "User Metrics",
    function: "Interaction",
    description: "User has engaged with the agent for more than 30 minuntes.",
  },
  {
    metric: "User Metrics",
    function: "Feedback - Chart Related",
    description: "Feedback about charts, visuals, chart types, or legends.",
  },
  {
    metric: "User Metrics",
    function: "Feedback - Data Related",
    description:
      "Feedback about data accuracy, inconsistencies, or report comparisons.",
  },
  {
    metric: "User Metrics",
    function: "Feedback - Feature Related",
    description:
      "Feedback about the agent’s insights, functionality, buttons, or overall user interface.",
  },
  {
    metric: "User Metrics",
    function: "Feedback - Speed Related",
    description: "Feedback about agent's speed or performance.",
  },
  {
    metric: "User Metrics",
    function: "Feedback - Others",
    description:
      "General or uncategorized feedback that does not fit into the predefined categories.",
  },
  {
    metric: "Question Metrics",
    function: "Data Retrieval",
    description:
      "Single-step questions that can be answered directly by locating or extracting existing data.",
  },
  {
    metric: "Question Metrics",
    function: "Multi-step",
    description:
      "Questions that require two or more stages of reasoning or calculation, often producing multiple data outputs.",
  },
  {
    metric: "Question Metrics",
    function: "Reasoning",
    description:
      "“Why” or “How” questions that involve explanation, interpretation, or hypothesis generation.",
  },
];
export default page1Queries;
